// tslint:disable:no-null-keyword
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { TextLoca } from "../generic/text/TextLoca";
export var DescriptionProducts = function (_a) {
    var item = _a.item;
    var locaDesc1 = item.locaKeyDesc1 && (React.createElement("div", { className: "farm-management-detail__description-one " + IdStyles.TextBoldAccent },
        React.createElement(TextLoca, { id: item.locaKeyDesc1 })));
    var locaDesc2 = item.locaKeyDesc2 && (React.createElement("div", { className: "farm-management-detail__description-two " + IdStyles.TextBoldAccent },
        React.createElement(TextLoca, { id: item.locaKeyDesc2 })));
    return locaDesc1 == undefined && locaDesc2 == undefined ? (React.createElement("div", { className: "flex__full" })) : (React.createElement("div", { className: "farm-management-detail__description" },
        locaDesc1,
        locaDesc2));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/DescriptionProducts.tsx
// module id = 2645
// module chunks = 3